import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { ChangesStatus } from '@editor2/types/changesStatus';
import { type RootState } from '@editor2/reducers/root';
import { bookToEditorFormProperties } from '@editor2/mappers/book';
import { checkLectureSlideDecksOrderChanged } from '@editor2/services/unsavedChangesService';
import AttributesChanges from './common/AttributesChanges';
import ChildrenChanges from './common/ChildrenChanges';
import ChangesHeader from './common/ChangesHeader';

interface Props {
	courseId: number;
}

const TocChanges: FC<Props> = (props) => {
	const { courseId } = props;

	const { changes, initialCourse, book, chapters, lecture_slide_decks } = useSelector(
		(state: RootState) => state.courses[courseId]
	);

	return (
		<div className="changeBlock">
			<ChangesHeader
				changesStatuses={changes.toc}
				headerTitle="TOC"
				link={`/courses/${courseId}`}
			/>

			{changes.toc.includes(ChangesStatus.Modified) && (
				<AttributesChanges
					currentEntity={book}
					initialEntity={initialCourse.book}
					mapper={bookToEditorFormProperties}
				/>
			)}
			{changes.toc.includes(ChangesStatus.ChildrenReorder) && (
				<ChildrenChanges
					currentIds={chapters.ids}
					initialIds={initialCourse.chapters.ids}
					changesEntity={changes.chapters}
					title="chapter"
				/>
			)}
			{checkLectureSlideDecksOrderChanged(changes) && (
				<ChildrenChanges
					currentIds={lecture_slide_decks.ids}
					initialIds={initialCourse.lecture_slide_decks?.ids ?? []}
					changesEntity={changes.lecture_slide_decks}
					title="file"
				/>
			)}
		</div>
	);
};

export default TocChanges;
